module.exports = __webpack_public_path__ + "static/media/AvenirLTPro-Medium.0150b233.ttf";